import React from 'react';

import ClientOnly from '../../../ClientOnly';
import { useVwp } from '../VwpContext';

import 'react-datepicker/dist/react-datepicker.css';
import scss from './Filters.module.scss';
import FiltersBase from './FiltersBase';

const FiltersModal = React.lazy(() => import('./FiltersModal'));

const Filters = () => {
    const { initialRegionId, region, weddingDate, filterModalPackageId, setRegion, setWeddingDate } = useVwp();
    const title = `${!!region ? region.Name : 'Wedding'} Packages`;

    return (
        <div className={scss.filterContainer}>
            <div className={scss.filterTitle}>{title}</div>
            <FiltersBase
                initialRegionId={initialRegionId}
                region={region}
                weddingDate={weddingDate}
                setRegion={setRegion}
                setWeddingDate={setWeddingDate}
            />
            {!!filterModalPackageId && <ClientOnly Component={FiltersModal} />}
        </div>
    );
};

export default Filters;